import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import style from "./style";
import CardContent from "@material-ui/core/CardContent";
import FieldToggle from "../../components/FieldToggle";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Divider from "@material-ui/core/Divider";
import React, {Component} from "react";
import MarkerFilterContext from "../../contexts/markerFilter";

export default class FloorPanel extends Component {
  // noinspection JSUnusedGlobalSymbols
  static contextType = MarkerFilterContext;

  render() {
    let {floor} = this.props;
    const markers = floor.markers();
    return (
      <Card>
        <CardHeader style={style.cardHeader} title={floor.name} subheader={`${markers.size} markers`} />
        {this.renderCardContent()}
      </Card>
    );
  }

  renderCardContent() {
    if (this.props.floor.markers().size) {
      return (
        <CardContent style={{paddingTop: 0}}>
          <FieldToggle
            value={this.context.getAllToggled()}
            label="Toggle All"
            labelPlacement="start"
            onChange={this.context.toggleAllMarkerFilter}
          />
          <List style={style.markerList}>{this.renderMarkerTypes()}</List>
        </CardContent>
      );
    }
  }

  renderMarkerTypes() {
    return this.getMarkerTypes(this.props.floor.markers()).map(markerType => {
      return this.renderMarkerType(markerType);
    });
  }

  renderMarkerType(markerType) {
    return (
      <div key={markerType._id}>
        <ListItem>
          <ListItemIcon>
            <img className="listItemIcon" src={markerType.image.path} alt={markerType.name} />
          </ListItemIcon>
          <ListItemText primary={markerType.name} />
          <ListItemIcon>
            <FieldToggle
              value={this.context.markerFilter[markerType._id]}
              onChange={() => this.context.toggleMarkerFilter(markerType._id)}
            />
          </ListItemIcon>
        </ListItem>
        <Divider />
      </div>
    );
  }

  // Create an array of all marker types on a floor
  getMarkerTypes(markers) {
    return markers.reduce((types, marker) => {
      const inArray = types.find(type => type._id === marker.type_id);
      return inArray ? types : [...types, marker.type()];
    }, []);
  }
}



// WEBPACK FOOTER //
// ./src/pages/Map/FloorPanel.jsx